export interface DatePart {
  id: string;
  name: string;
}

export function fromDates() {
  const getDays = (): DatePart[] => {
    return Array.from(Array(31).keys()).map(v => {
      const day = (v + 1).toString();
      return {id: day, name: day};
    });
  };

  const getMonths = (): DatePart[] => {
    return [
      { id: "1", name: "January" },
      { id: "2", name: "February" },
      { id: "3", name: "March" },
      { id: "4", name: "April" },
      { id: "5", name: "May" },
      { id: "6", name: "June" },
      { id: "7", name: "July" },
      { id: "8", name: "August" },
      { id: "9", name: "September" },
      { id: "10", name: "October" },
      { id: "11", name: "November" },
      { id: "12", name: "December" }
    ];
  };

  const getYears = (): DatePart[] => {
    const currentYear = new Date().getFullYear();
    return Array.from(Array(121).keys()).map(v => {
      const year = (currentYear - v).toString();
      return {id: year, name: year};
    });
  };

  return {
    getDays,
    getMonths,
    getYears
  };
}

export function createValueFromParts (day: string, month: string, year: string): string {
  return `${year.padStart(4, "0")}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}
